var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{staticStyle:{"display":"flex","justify-content":"center","padding":"10px 20px"},attrs:{"span":24}},[_c('el-image',{attrs:{"src":_vm.adUrl},on:{"click":function($event){return _vm.goAdLink(_vm.adLink)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f029af06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uConnectReservation/advertisementSection.vue
// module id = null
// module chunks = 